import { createFileRoute } from "@tanstack/react-router";
import { KostenDetailPage, kostenDetailHead } from "../components/KostenDetailPage";
import { kostenDetails } from "../lib/kosten-detail-content";

const detail = kostenDetails["uitbouw-kosten-per-m2"]!;

export const Route = createFileRoute("/uitbouw-kosten-per-m2")({
  head: () => kostenDetailHead(detail),
  component: () => <KostenDetailPage detail={detail} />,
});
